import { PaymentPartnerEditingController } from './paymentPartnerEditing.controller';
import template from './paymentPartnerEditing.html';

export const paymentPartnerEditingComponent = {
  name: 'paymentPartnerEditing',
  restrict: 'E',
  template,
  controller: PaymentPartnerEditingController,
  controllerAs: 'vm',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
};
